import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CharacteristicGroup as SchemaCharacteristicGroup } from '../schemas/CharacteristicGroup';
import { type CreateCharacteristicGroupRequest as SchemaCreateCharacteristicGroupRequest } from '../schemas/CreateCharacteristicGroupRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Characteristics
 */
export const CreateCharacteristicGroupContentType = 'application/json' as const;
export type CreateCharacteristicGroupRequest = SchemaCreateCharacteristicGroupRequest;
export type CreateCharacteristicGroupResponses = LinkCommonErrorResponses & {
    /**
     * @description Characteristic group created successfully
     */
    '200': {
        'application/json': SchemaCharacteristicGroup;
    };
};
export type CreateCharacteristicGroupResponseSuccess = CreateCharacteristicGroupResponses['200']['application/json'];
export type CreateCharacteristicGroupSearchParams = undefined;
export type CreateCharacteristicGroupPathParameters = undefined;
export const CreateCharacteristicGroupUrl = '/characteristics/groups' as const;
export const CreateCharacteristicGroupMethod = 'POST' as const;
export const getCreateCharacteristicGroupUrl = (_params?: CreateCharacteristicGroupPathParameters) =>
    CreateCharacteristicGroupUrl;
